import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router';
import { Step } from '../NewRegistrationContext';


let Progress = () => {
    let { step } = useParams<{ step: Step }>();
    let { formatMessage } = useIntl();

    /* Steps:
        1. /searchproduct
        2. /warrantyavailable (se non è autenticato)
        3. /dateandreceipt (se autenticato)
        4. /qrcode (se qrcode mandatory)
        5. /locatestore
    */
    let [progress, setProgress] = useState({
        pct: 0,
        text: formatMessage({ id: 'START_HERE' })
    });

    useEffect(() => {
        switch (step) {
            case Step.WarrantyAvailable:
            case Step.DateAndReceipt:
                setProgress({
                    pct: 25,
                    text: `25% ${formatMessage({ id: 'COMPLETED' })}`
                });
                break;

            case Step.QrCode:
                setProgress({
                    pct: 50,
                    text: `50% ${formatMessage({ id: 'COMPLETED' })}`
                });
                break;

            case Step.LocateStore:
                setProgress({
                    pct: 75,
                    text: `75% ${formatMessage({ id: 'COMPLETED' })}`
                });
                break;

            default:
                setProgress({
                    pct: 0,
                    text: formatMessage({ id: 'START_HERE' })
                });
                break;
        }
    }, [step])

    return (
        <div className="loader">
            <span style={{ width: `${progress.pct}%` }}><span>
                <i></i>{progress.text}</span>
            </span>
        </div>
    );
}

export default Progress;